// The verbatim download payload the controls strips ask for, ported from onExportVerbatim on the
// coffee block base. The page is handed a resolved payload and only downloads it.
//
// A block key spells out what the verbatims are being read under -- the question, its sub-question
// or answer variant, and, for a heatmap, the cluster -- and the page model composes the id the
// export service addresses from those parts.

import { getReportQuestionId, getSurveyAssets, humanizedFiltersString } from '@aytm/app/stats/lib/stat-page'
import PageGlobals from '@aytm/app/stats/lib/page/page-globals'

export const VERBATIM_FILE_TYPE = 'csv'
export const VERBATIM_EXPORT_TYPE = 'verbatim'

// the codes variant of the export is the one that keeps the tags
const WITH_CODES = 'codes'

const clusterKeys = () => getSurveyAssets('hm.cluster').map(asset => asset.uid.replace('.', '_').replace('@', '_'))

const clusterKeyReg = () =>
  new RegExp(
    `^([vcx]q|cl|tl|sn)?(\\d+)(?:[_-](\\d+)(?![a-zA-Z]))?(?:[.](\\d+)(?![a-zA-Z]))?(?:[.](${clusterKeys().join('|')}))$`,
    'i'
  )

const QUESTION_KEY_REG =
  /^([vcx]q|cl|tl|sn)?(\d+)(?:[_-](\d+)(?![a-zA-Z]))?(?:[.](\d+)(?![a-zA-Z]))?(?:[.](\d+)(?![a-zA-Z]))?$/i

const matchKey = key => String(key).match(clusterKeyReg()) || String(key).match(QUESTION_KEY_REG)

// What the page is asked to download, or null where there is nothing to ask for: a file the strip
// does not offer, or a key no question id can be composed from.
export const calcVerbatimDownloadParams = ({ key, fileType, exportType, exportExtra } = {}) => {
  if (VERBATIM_FILE_TYPE !== fileType || VERBATIM_EXPORT_TYPE !== exportType) return null

  const match = matchKey(key)
  if (!match) return null

  const [qid, cluster] = String(getReportQuestionId(null, match.slice(1), false)).split('.cluster.')

  const extra = {
    user: PageGlobals.USERNAME,
    customDomain: PageGlobals.SUBDOMAIN,
    filters: humanizedFiltersString(),
    qid
  }

  if (undefined !== cluster) extra.cluster = cluster

  return {
    fileType,
    exportType,
    exportOptions: { ignoreTags: WITH_CODES !== exportExtra, extra }
  }
}
